module.exports = __webpack_public_path__ + "media/images/landing/bg/case-nestle/instagram-2-9fa28387e9fb1dc012c901d0baa1f7b3.jpg";